// import { Caveat } from '#~/common/editor/index.js';
import { Columns } from '../layout.jsx';
import { Preview } from '../preview.jsx';
// import { useStore } from '../store/hooks.js';
import { Details } from './details.jsx';
import type { Props } from './types.js';
// import { vendorName } from '@studio/design-system/themes/vendor.js';
// import { isNotNil } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';

/** `<Manufacturer>` panel. */
export const Manufacturer = (props: Props): ReactElement => {
  // const bWarning = useStore((µ) => isNotNil(µ.candidate.control) && µ.manufacturer.isOther);

  return (
    <div {...props}>
      {/* <h2>Make and model</h2> */}

      {/* <Caveat
        severity={bWarning ? 'warning' : 'info'}
        title={
          bWarning
            ? "You must first select your camera's brand and model before starting calibration."
            : `By selecting your camera's make and model, ${vendorName()} will calibrate your camera to enable Auto-Tracking and Magic Movement tools.`
        }
      /> */}

      {/* <HRule /> */}

      <Columns>
        <Columns.Column>
          <h3>Source details</h3>
          <Details />
        </Columns.Column>

        <Columns.Column>
          <h3>Video preview</h3>
          <Preview />
        </Columns.Column>
      </Columns>
    </div>
  );
};
